import React from 'react';
import variables from '../../../utils/variables';
import { setActiveTab } from '../../../actions/navBar';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';

const Tabs = (props) => {
    const handleChange = (newValue) => {
        if (newValue === 'blog') {
            window.open('https://blog.omniflix.network', '_blank');

            return;
        }

        const el = document.getElementById(newValue);
        if (el && el.getBoundingClientRect() && el.getBoundingClientRect().top) {
            window.scrollTo({
                top: window.scrollY + el.getBoundingClientRect().top - props.size,
                behavior: 'smooth',
            });
        }

        props.onChange(newValue);
    };

    return (
        <div className="tabs">
            <span onClick={() => handleChange('ecosystem')}>
                {variables[props.lang].ecosystem}
            </span>
            <span onClick={() => handleChange('why')}>
                {variables[props.lang].why}
            </span>
            <span onClick={() => handleChange('network')}>
                {variables[props.lang].network}
            </span>
            <span onClick={() => handleChange('infrastructure')}>
                {variables[props.lang].infrastructure}
            </span>
            <span onClick={() => handleChange('dApps')}>
                {variables[props.lang].dApps}
            </span>
            <span onClick={() => handleChange('roadmap')}>
                {variables[props.lang].roadmap}
            </span>
            <span onClick={() => handleChange('blog')}>
                {variables[props.lang].blog}
            </span>
        </div>
    );
};

Tabs.propTypes = {
    lang: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
};

const stateToProps = (state) => {
    return {
        lang: state.language,
        size: state.navBar.windowSize,
    };
};

const actionToProps = {
    onChange: setActiveTab,
};

export default connect(stateToProps, actionToProps)(Tabs);
